/**
 * utils.js
 * Created by calhosh on 4/21/2020.
 */
import React from 'react';
import _ from 'lodash';
import env from './env';

import resources from '../resources/resources';
import * as constants from './uiconstants';
import NumberFormat from 'react-number-format';
import {ThemeProvider} from 'styled-components';

let lang = env.getLanguage();
export let currentResource = resources(lang);
export let labels = currentResource.labels;
export let reviewNoteLabels = currentResource.reviewNoteLabels;
export let accountType = currentResource.AccountType;

export let currentKendoValue = [];
export let LocalizedUIConstants = constants;

let updateConstantsWithLocale = (prop) => {
	prop.map((p) => {
		p['localizedlabel'] = currentResource[p.label] || p.label;
		return p;
	});
	return prop;
};

const fileExtensionMapping = {
	mapping: [
		{keys: ['XLS', 'XLSX', 'XLSM', 'CSV', 'XLTX', 'XLAM', 'XLSB'], mapIconName: 'excel'},
		{keys: ['DOCX', 'DOC', 'DOCM'], mapIconName: 'word'},
		{keys: ['PDF'], mapIconName: 'pdf'},
		{keys: ['JPG', 'JPEG', 'GIF', 'PNG'], mapIconName: 'jpg'},
		{keys: ['PST', 'MSG'], mapIconName: 'outlook'},
		{keys: ['SMART', 'SMT', 'LS'], mapIconName: 'smart-evidence'},
		{keys: ['SMTA'], mapIconName: 'Smt-icon'},
		{keys: ['ZIP'], mapIconName: 'zip'},
		{keys: ['FORM'], mapIconName: 'form'}
	]
};

// get document extension ico for print view to avoid going to vlotron doc name componant
export function getDocumentExtension(fileExt) {
	if (fileExt === undefined) {
		fileExt = '';
	}
	if (fileExtensionMapping) {
		let mappedName = _.find(fileExtensionMapping.mapping, function(item) {
			return item.keys.indexOf(fileExt.toUpperCase()) >= 0;
		});
		if (mappedName) {
			return mappedName.mapIconName + '-blank-small';
		}
		return 'unknown';
	}
}

/*set user selected language*/
export const setLanguage = (language) => {
	if (language) {
		currentResource = resources(language);
		labels = currentResource.labels;
	}
	let constantCollections = _.pickBy(LocalizedUIConstants, (c) => _.isArray(c) && _.isObject(c[0]));
	LocalizedUIConstants = _.forEach(constantCollections, updateConstantsWithLocale);
};

/*user based negative number formatting*/
export const negativeNumberFormatting = (
	negativeFormat,
	valFormatter,
	numberValue,
	isDecimal = false,
	decimalScale = 0,
	userSuffix = ''
) => {
	// convert negative number to positive number
	numberValue = Math.abs(numberValue);

	switch (negativeFormat) {
		case 0:
			return (
				<NumberFormat
					value={numberValue}
					prefix={'('}
					suffix={')' + userSuffix}
					displayType="text"
					thousandSeparator={valFormatter.thousandSeparator}
					thousandsGroupStyle={valFormatter.thousandsGroupStyle}
					decimalSeparator={valFormatter.decimalSeparator}
					decimalScale={decimalScale}
					fixedDecimalScale={isDecimal}
					isNumericString
				/>
			);
		case 1:
			return (
				<NumberFormat
					value={numberValue}
					prefix={'-'}
					suffix={userSuffix}
					displayType="text"
					thousandSeparator={valFormatter.thousandSeparator}
					thousandsGroupStyle={valFormatter.thousandsGroupStyle}
					decimalSeparator={valFormatter.decimalSeparator}
					decimalScale={decimalScale}
					fixedDecimalScale={isDecimal}
					isNumericString
				/>
			);
		case 2:
			return (
				<NumberFormat
					value={numberValue}
					prefix={'- '}
					suffix={userSuffix}
					displayType="text"
					thousandSeparator={valFormatter.thousandSeparator}
					thousandsGroupStyle={valFormatter.thousandsGroupStyle}
					decimalSeparator={valFormatter.decimalSeparator}
					decimalScale={decimalScale}
					fixedDecimalScale={isDecimal}
					isNumericString
				/>
			);
		case 3:
			return (
				<NumberFormat
					value={numberValue}
					suffix={'-' + userSuffix}
					displayType="text"
					thousandSeparator={valFormatter.thousandSeparator}
					thousandsGroupStyle={valFormatter.thousandsGroupStyle}
					decimalSeparator={valFormatter.decimalSeparator}
					decimalScale={decimalScale}
					fixedDecimalScale={isDecimal}
					isNumericString
				/>
			);
		case 4:
			return (
				<NumberFormat
					value={numberValue}
					suffix={' -' + userSuffix}
					displayType="text"
					thousandSeparator={valFormatter.thousandSeparator}
					thousandsGroupStyle={valFormatter.thousandsGroupStyle}
					decimalSeparator={valFormatter.decimalSeparator}
					decimalScale={decimalScale}
					fixedDecimalScale={isDecimal}
					isNumericString
				/>
			);
		default:
			return (
				<NumberFormat
					value={numberValue}
					prefix={'-'}
					suffix={userSuffix}
					displayType="text"
					thousandSeparator={valFormatter.thousandSeparator}
					thousandsGroupStyle={valFormatter.thousandsGroupStyle}
					decimalSeparator={valFormatter.decimalSeparator}
					decimalScale={decimalScale}
					fixedDecimalScale={isDecimal}
					isNumericString
				/>
			);
	}
};

/**
 * Return number formatted data
 * @param {Number} userPreferenceNumberFormat - number format.
 * @param {Number} userNegativeNumberFormat - negative number format.
 * @param {string} freeText - freeText.
 * @param {string} suffix - suffix.
 * @returns {string} return number formatted value
 **/
export const negativeNumberFormattedText = (
	userPreferenceNumberFormat,
	userNegativeNumberFormat,
	freeText,
	suffix = ''
) => {
	let formatedText = numberFormattedText(userPreferenceNumberFormat, freeText);
	if (freeText && freeText >= 0) {
		return formatedText + suffix;
	}

	formatedText = formatedText.replace('-', '');

	switch (userNegativeNumberFormat) {
		case 0:
			return '(' + formatedText + ')' + suffix;
		case 1:
			return '-' + formatedText + suffix;
		case 2:
			return '- ' + formatedText + suffix;
		case 3:
			return formatedText + '-' + suffix;
		case 4:
			return formatedText + ' -' + suffix;
		default:
			return '(' + formatedText + ')' + suffix;
	}
};

/**
 * Return number formatted data
 * @param {Number} userPreferenceNumberFormat - number format.
 * @param {string} freeText - freeText.
 *  @returns {string} return number formatted value
 **/
export const numberFormattedText = (userPreferenceNumberFormat, freeText) => {
	switch (userPreferenceNumberFormat) {
		case 0:
			return freeText?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		case 1:
			let numberText = String(freeText);
			let subText = '';
			let appendNumber = '';

			const index = numberText.indexOf('.');
			const arr = [];

			if (index !== -1) {
				arr.push(...numberText.split('.'));
				numberText = arr[0];
			}

			if (numberText.length > 3) {
				subText = numberText.substring(0, numberText.length - 3);
				appendNumber = ',' + numberText.substring(numberText.length - 3, numberText.length);
			} else {
				subText = numberText;
			}

			let formattedText = `${subText.toString().replace(/(\d)(?=(\d{2})+(?!\d))/g, '$1,')}${appendNumber}`;

			if (index !== -1) {
				formattedText = `${formattedText}.${arr[1]}`;
			}

			return formattedText;
		case 2:
			return freeText !== undefined && freeText !== null
				? freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
				: '';
		case 3:
			return freeText !== undefined && freeText !== null
				? freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
				: '';
	}
};

/*set thousand separator*/
export const setThousandSeparator = (numberFormat) => {
	let thousandSeparator = '',
		decimalSeparator = '.',
		thousandsGroupStyle = 'thousand';
	switch (
		numberFormat === undefined || numberFormat === '' || numberFormat === 0
			? constants.numberFormats[0].id
			: numberFormat
	) {
		case constants.numberFormats[0].id /*'1,234,567,890'*/:
			thousandSeparator = ',';
			break;
		case constants.numberFormats[1].id /*need to figure this out*/ /*'1,23,45,67,890'*/:
			thousandSeparator = ',';
			thousandsGroupStyle = 'lakh';
			break;
		case constants.numberFormats[2].id /*'1 234 567 890'*/:
			thousandSeparator = ' ';
			break;
		case constants.numberFormats[3].id /*'1.234.567.890'*/:
			thousandSeparator = '.';
			/*Decimal and thousands separator cannot be the same. We dont show decimal, so just change it*/
			decimalSeparator = ',';
			break;
		// case constants.numberFormats[4].value /*"1'234'567'890"*/:
		// 	thousandSeparator = `'`;
		// 	break;
		// case constants.numberFormats[5].value /*need to figure this out*/ /*'12,3456,7890'*/:
		// 	thousandSeparator = ',';
		// 	thousandsGroupStyle = 'wan';
		// 	break;
	}
	return {thousandSeparator, decimalSeparator, thousandsGroupStyle};
};

/*set number rounding*/
export const setNumberRounding = (rounding, numberValue) => {
	let roundedNumber = 0;
	switch (rounding === undefined || rounding === '' ? constants.roundingOptions[0].value : rounding) {
		case constants.roundingOptions[0].value /*none*/:
			roundedNumber = Math.round(Number(numberValue));
			break;
		case constants.roundingOptions[1].value /*thousands*/:
			roundedNumber = Math.round(Number(numberValue) / 1000);
			break;
		case constants.roundingOptions[2].value /*millions*/:
			roundedNumber = Math.round(Number(numberValue) / 1000000);
			break;
		case constants.roundingOptions[3].value /*lakhs*/:
			roundedNumber = Math.round(Number(numberValue) / 10000);
			break;
		case constants.roundingOptions[4].value /*crores*/:
			roundedNumber = Math.round(Number(numberValue) / 10000000);
			break;
	}

	return roundedNumber;
};

/**
 * Given an event object, checks wether the ENTER key alone has been pressed (without any combinations)
 * @param {Event} evt - Event object.
 *  @returns {boolean} true if the ENTER key was pressed; otherwise false.
 **/
export function isEnterKeyPressed(evt) {
	if (evt && evt.keyCode !== undefined) {
		const currentKey = evt.keyCode;
		return currentKey === constants.keyCode.ENTER && !evt.shiftKey;
	}
}

export function isNullOrUndefined(value) {
	return value === null || value === undefined;
}

export function isFraudRiskOrSignificantRisk(value) {
	return value === constants.riskTypes.FRAUDRISK || value === constants.riskTypes.SIGNIFICANTRISK;
}

export function isNullOrEmpty(value) {
	return isNullOrUndefined(value) || value.trim() === '';
}

export const isNullOrWhitespace = (input) => {
	return !input || !input.trim();
};

/**
 * Compares two arrays, given by prev and next. Two arrays are considered equal if they have the same elements, regardless of the order.
 * @param {Array} prev First array.
 * @param {Array} next Second array.
 * @returns true if both arrays are equal, false otherwise.
 */
export function arrayCompare(prev, next) {
	if (isNullOrUndefined(prev) !== isNullOrUndefined(next)) {
		return false;
	}

	if (Array.isArray(prev) !== Array.isArray(next)) {
		return false;
	}

	// Counts are different
	if (prev.length !== next.length) return false;

	// They don't have the same elements (dont care about the order)
	for (let i = 0; i < prev.length; i++) {
		if (!next.includes(prev[i])) return false;
	}

	return true;
}

/**
 * Normalizes a collection of elements based on redux's docs recommendations.
 * https://redux.js.org/recipes/structuring-reducers/normalizing-state-shape
 * @param {Array} value A collection of elements to be normalized.
 * @param {String} key A string representing the element's id field name.
 * @param {object} initialState An initial state with a normalized form.
 * @param {function} mergeStrategy A strategy to merge already detected entities.
 * @param {Boolean} replace If true, overwrites the state with the items in value.
 * @returns {object} An object with the normalized state.
 */
export function normalize(
	value,
	key = 'id',
	initialState = undefined,
	mergeStrategy = lastOneWinsMergeStrategy,
	replace = false
) {
	let result = {
		byId: {},
		allIds: []
	};

	if (initialState) {
		result = {...initialState};
		result.byId = replace || !initialState.byId ? {} : {...initialState.byId};
		result.allIds = replace || !initialState.allIds ? [] : [...initialState.allIds];
	}

	if (!(value === null || value === undefined || (Array.isArray(value) && !value.length > 0))) {
		for (const element of value) {
			if (element !== null) {
				let id = element[key];

				if (!result.byId[id]) {
					result.allIds.push(id);
				}

				mergeStrategy(id, element, result);

				if (key !== 'id') {
					delete result.byId[id][key];
				}
			}
		}
	}

	return result;
}

/**
 * Grabs an entity received from a child and mutates the store accordingly, last one wins.
 * @param {number} id The entity's Id.
 * @param {object} element The response's iterated element.
 * @param {object} result The normalized slice.
 */
export function lastOneWinsMergeStrategy(id, element, result) {
	result.byId[id] = {
		...result.byId[id],
		...element,
		id
	};
}

/**
 * Grabs an entity received from a child and mutates the store accordingly, if a relationship is found, then the received value is added to the current state.
 * @param {number} id The entity's Id.
 * @param {object} element The response's iterated element.
 * @param {object} result The normalized slice.
 */
export function concatMergeStrategy(id, element, result) {
	if (!result.byId[id]) {
		result.byId[id] = {};
	} else {
		result.byId[id] = {...result.byId[id]};
	}

	for (const entry of Object.entries(element)) {
		const key = entry[0],
			value = entry[1];

		// If the Api response property value is an array
		if (Array.isArray(value)) {
			// this might be a new prop which was not there before
			if (!result.byId[id].hasOwnProperty(key)) {
				result.byId[id][key] = value;
			} else {
				// The item in the store has a property by this name, but it's null/undefined. Initialize it as an empty array
				if (!result.byId[id][key]) {
					result.byId[id][key] = [];
				}
				// which is not empty
				if (value.length > 0) {
					if (
						// and is populated with primitive values
						!(value[0] instanceof Object)
					) {
						for (const item of value) {
							if (result.byId[id][key].indexOf(item) < 0) {
								result.byId[id][key] = result.byId[id][key].concat(item);
							}
						}
					} else {
						result.byId[id][key] = value;
					}
				}
			}
		} else {
			// there's a chance that an array of objects override the previous value
			// Only overwrite the property in the store if it's not an array
			// Otherwise, only add it if it's "truthy"
			if (!Array.isArray(result.byId[id][key])) {
				result.byId[id][key] = value;
			} else {
				if (value !== null && value !== undefined) {
					result.byId[id][key] = result.byId[id][key].concat(value);
				}
			}
		}
	}
}

/**
 * Grabs an entity received from a child and mutates the store accordingly, if last one has a truthy value, this new value replaces the existing one.
 * @param {number} id The entity's Id.
 * @param {object} element The response's iterated element.
 * @param {object} result The normalized slice.
 */
export function truthyWinsMergeStrategy(id, element, result) {
	if (element !== null) {
		result.byId[id] = {
			...result.byId[id]
		};

		Object.entries(element).forEach((entry) => {
			const key = entry[0],
				value = entry[1];

			if (key === 'id') {
				result.byId[id][key] = id;
			} else if (value !== null && value !== undefined) {
				result.byId[id][key] = value;
			} else if (result.byId[id][key] === undefined) {
				result.byId[id][key] = value;
			}
		});
	}
}

/**
 * Normalizes an state based on a tree strucutre, using stack recursion.
 * @param {string} entity The current entity's name.
 * @param {array} data The data to be normalized.
 * @param {object} schema An schema configuration.
 * @param {object} initialState An accumulator object, used internaly, do not pass.
 * @param {array} parent An array which contains parent info, used internaly, do not pass.
 * @returns {object} A normalized state.
 */
export function recursiveNormalize(entity, data, schema = undefined, initialState = undefined, parent = undefined) {
	const {entity: _entity, key} = (schema && schema[entity]) || {entity, key: 'id'};

	let slice;
	slice = handleInitialState(initialState, slice, _entity);

	for (const element of data) {
		const id = element[key];
		if (!slice[_entity].byId[id]) {
			slice[_entity].allIds.push(id);
		}

		const newEntity = applyNewEntity(slice, _entity, element, key, id, parent);

		Object.entries(element).forEach((entry) => {
			slice = applyNewEntry(entry, slice, _entity, key, id, schema, newEntity);
		});

		slice[_entity].byId[id] = newEntity;
	}

	return slice;
}

function handleInitialState(initialState, slice, entity) {
	if (initialState) {
		slice = initialState;
		if (!slice[entity]) {
			slice[entity] = {
				byId: {},
				allIds: []
			};
		} else {
			slice[entity] = {
				...slice[entity],
				allIds: [...slice[entity].allIds]
			};
		}
	} else {
		slice = {
			[entity]: {
				byId: {},
				allIds: []
			}
		};
	}
	return slice;
}

function applyNewEntity(slice, entity, element, key, id, parent) {
	let newEntity;
	if (!slice[entity].byId[id]) {
		newEntity = {id: element[key]};
		if (parent) {
			newEntity[parent[0]] = [parent[1]];
		}
	} else {
		newEntity = {...slice[entity].byId[id]};
		if (parent) {
			newEntity[parent[0]].push(parent[1]);
		}
	}
	return newEntity;
}

function applyNewEntry(entry, slice, entity, key, id, schema, newEntity) {
	if (Array.isArray(entry[1]) && entry[1].length > 0 && entry[1][0] instanceof Object) {
		slice = {
			...slice,
			...recursiveNormalize(entry[0], entry[1], schema, slice, [entity, id])
		};
		newEntity[schema[entry[0]] ? schema[entry[0]].entity : entry[0]] = entry[1].map(
			(item) => item[schema[entry[0]] ? schema[entry[0]].key : 'id']
		);
	} else {
		if (entry[0] !== key) {
			newEntity[entry[0]] = entry[1];
		}
	}
	return slice;
}

/**
 * Creates a new entity in a normalized state slice.
 * @param {object} slice The normalized slice.
 * @param {object} data The entity to be created.
 * @param {string} key The entity's key name, defaluts to id.
 * @returns {object} The mutated slice.
 */
export function normalizedCreate(slice, data, key = 'id') {
	const id = data[key];

	const result = {
		byId: {
			...slice.byId,
			[id]: {
				...data,
				id
			}
		},
		allIds: slice.allIds.concat(id)
	};

	if (key !== 'id') {
		delete result.byId[id][key];
	}

	return result;
}

/**
 * Updates a normalized entry based on an entity and a initial state.
 * @param {any} id The entry's Id.
 * @param {object} entity The entity to be used as patch.
 * @param {object} state A normalized updated state object.
 * @returns {object} A normalized updated state object.
 */
export function normalizedUpdate(id, entity, state) {
	let result;
	if (!state || _.isEmpty(state)) {
		result = normalize();

		result.byId[id] = {
			...entity,
			id
		};
		result.allIds.push(id);
	} else {
		result = {...state};

		if (result.byId[id]) {
			result.byId[id] = {
				...state.byId[id],
				...entity
			};
		}
	}

	return result;
}

/**
 * Removes an entry from a normalized state slice.
 * @param {object} slice The normalized slice.
 * @param {number} id The entity's Id.
 * @returns {object} The mutated slice.
 */
export function normalizedDelete(slice, id) {
	let result = {
		...slice,
		allIds: slice?.allIds?.filter((value) => value !== id)
	};

	if (result?.byId) {
		result.byId = {
			...result.byId
		};
		delete result.byId[id];
	}

	return result;
}

/**
 * Iterates through a normalized slice and deletes the specified relationship.
 * @param {object} slice A normalized slice to analyze.
 * @param {string} entity The name of the related entity key.
 * @param {number} id The related entity's Id.
 * @returns {object} The corresponding slice porperly mutated.
 */
export function deleteRelationship(slice, entity, id) {
	let result;
	if (slice) {
		result = slice;
		let cloned = false;

		Object.entries(slice.byId).forEach((entry) => {
			const key = entry[0],
				value = entry[1];

			if (value[entity] && Array.isArray(value[entity]) && value[entity].length > 0 && value[entity].indexOf(id) > -1) {
				if (!cloned) {
					result = {
						...slice,
						byId: {
							...result.byId
						}
					};
					cloned = true;
				}

				result.byId[key] = {
					...result.byId[key],
					[entity]: result.byId[key][entity].filter((entityId) => entityId !== id)
				};
			}
		});
	}

	return result;
}

/**
 * Check if a reference is null or undefined. Plus check for stringified null/undefined.
 * @param {*} value reference to check.
 * @returns {Bool} true if null/undefined/'null'/'undefined'
 */
export function isNullOrUndefinedEx(value) {
	return isNullOrUndefined(value) || value === 'null' || value === 'undefined';
}

/**
 * Check if a function reference is valid.
 * @param {Function} fn function referece to check.
 * @returns {Bool} true if function is valid, false if not.
 */
export function isValidFunction(fn) {
	return !isNullOrUndefined(fn) && typeof fn === 'function';
}

/**
 *	Check if value is positive integer.
 * @param {*} value value to check.
 * @param {Boolean} strictCheck false if allow parsting string as integer, true if not
 * @returns {Boolean} true if value is positive integer, false if not.
 */
export function isValuePositiveInteger(value, strictCheck = false) {
	if (isNullOrUndefinedEx(value)) {
		return false;
	}
	const parseAndCheck = (value) => {
		const valueAsNumber = Number(value);
		if (isNaN(valueAsNumber)) {
			return false;
		}
		return constants.positiveIntegerRegex.test(valueAsNumber);
	};
	switch (typeof value) {
		case 'bigint':
		case 'number':
			return intRegex.test(value);
		case 'string':
			return strictCheck ? false : parseAndCheck(value);
		default:
			return false;
	}
}

/**
 * Returns the HTTP response code given by an API call.
 * @param {Object} action Redux API action.
 * @returns HTTP status code from the API response.
 */
export function getApiResponseCode(action) {
	const responseCode = action.responseObj?.status;
	return responseCode;
}

/**
 * Check if an API response is OK.
 * @param {Object} action Redux API action.
 * @returns {Boolean} true if the response is OK, false if not.
 */
export function isApiResponseOk(action) {
	const responseCode = getApiResponseCode(action);
	const successCodes = [
		constants.HttpStatusCodes.Ok,
		constants.HttpStatusCodes.NoContent,
		constants.HttpStatusCodes.Created
	];

	return !isNullOrUndefined(action.response) && successCodes.includes(responseCode);
}

/**
 * Check if value can be parsed as Number.
 * @param {*} value value to check.
 * @returns {Boolean} true if it can be parsed as Number, false if not.
 */
export function isValueParseableAsNumber(value) {
	if (isNullOrUndefinedEx(value)) {
		return false;
	}
	if (typeof value === 'number') {
		return true;
	}
	return !isNaN(Number(value));
}

/**
 * Check if value can be parsed as Integer.
 * @param {*} value value to check.
 * @returns {Boolean} true if it can be parsed as Integer, false if not.
 */
export function isValueParseableAsInteger(value) {
	if (!isValueParseableAsNumber(value)) {
		return false;
	}

	return constants.integerRegex.test(value);
}

/**
 * Builds an array of properties in a JsonPatch compliant format.
 * @param {String} path JsonPatch path property.
 * @param {Object} value Value for the property being patched.
 * @param {Array} accumulator List of properties to be sent for the PATCH endpoint.
 * @param {String} operation Operation type for the property. "replace" by default.
 * @returns {Array} Array of properties to be updated in a PATCH API call.
 */
export function buildJsonPatchData(path, value, accumulator = [], operation = 'replace') {
	let jsonPatchData = accumulator;
	if (!jsonPatchData) {
		jsonPatchData = [];
	}

	if (path) {
		const patchDataItem = {
			op: operation,
			path: path.startsWith('/') ? path : '/' + path,
			value: value
		};

		const pathIndex = jsonPatchData.findIndex((item) => item.path === path);
		if (pathIndex < 0) {
			jsonPatchData.push(patchDataItem);
		} else {
			jsonPatchData[pathIndex] = patchDataItem;
		}

		return jsonPatchData;
	}
}

export const accountTypeIdToLabelIdentfy = {
	[constants.AccountType.Significant]: labels.identifySignificantAccounts,
	[constants.AccountType.LimitedRisk]: labels.identifyLimitedAccounts,
	[constants.AccountType.InSignificant]: labels.identifyInsignificantAccounts
};

export const accountTypeIdToLabel = {
	[constants.AccountType.Significant]: labels.significantAccounts,
	[constants.AccountType.LimitedRisk]: labels.limitedAccounts,
	[constants.AccountType.InSignificant]: labels.insignificantAccounts
};

export const getPriorPeriodChange = (priorBalance, currentBalance) => {
	if (priorBalance && currentBalance) {
		let finalResult = [(currentBalance - priorBalance) / priorBalance] * 100;
		// This handles the scenario where current balance is still not positive but there was a significant
		// increase in comparison to the prior year value. We may still be negative but are in a better position
		// than before.
		if (finalResult < 0 && currentBalance > priorBalance) {
			return Math.abs(finalResult);
		}
		return finalResult;
	} else {
		return null;
	}
};

/**
 * Check if an element is a valid DOM element. Useful for checking return of querySelector.
 * @param {*} reference - A reference to a DOM element.
 * @returns {Boolean} - wheter if reference is a valid DOM element.
 */
export const isValidDOMElement = (reference) => !isNullOrUndefined(reference) && reference instanceof HTMLElement;

export const waitAllLoaders = (maxCycles = 25, cycleTimeMs = 200) =>
	new Promise((resolve, _) => {
		const loaderInterval = setInterval(() => {
			const haveProgressBar = document.querySelector('.motif-progress-loader');
			if (!haveProgressBar || maxCycles <= 0) {
				resolve(clearInterval(loaderInterval));
			}
			maxCycles--;
		}, cycleTimeMs);
	});

/**
 * Trim text in paragraph text.
 * @param {string} text (<p>....</p>)
 * @returns {string} trim the text inside the paragraph and return the paragraph text.
 */
export const trimParagraphEditor = (value) => {
	value = value?.replaceAll('&nbsp;', ' ');
	let paraStartTag = '<p>';
	let paraEndTag = '</p>';

	let firstIndex = value?.indexOf(paraStartTag);
	let lastIndex = value?.lastIndexOf(paraEndTag);

	if (firstIndex === 0 && lastIndex > -1) {
		value = paraStartTag + value.substring(firstIndex + 3, lastIndex).trim() + paraEndTag;
	}
	return value;
};

// Ares | Cards | Demarcation line and Kronos  cards view
export const GetCardTypeForBody = (body, isAresView, isViewportBody) => {
	if (isAresView) {
		// Bodies shown as a viewport do not show any borders
		if (isViewportBody) {
			return constants.AresFormBodyBorders[1];
		} else if (
			body?.bodyTypeId === constants.formBodyType.Slider ||
			body?.bodyTypeId === constants.formBodyType.SliderLegend ||
			body?.bodyTypeId === constants.formBodyType.RadioButtonHorizontal ||
			body?.bodyTypeId === constants.formBodyType.ToggleThreeButton ||
			body?.bodyTypeId === constants.formBodyType.ToggleTwoButton ||
			body?.bodyTypeId === constants.formBodyType.ToggleSwitch ||
			body?.bodyTypeId === constants.formBodyType.ToggleSwitchTwoOptions
		) {
			return constants.FormBodyBorders[body?.cardTypeId] || constants.FormBodyBorders[1];
		}
		return constants.AresFormBodyBorders[body?.cardTypeId] || constants.AresFormBodyBorders[1];
	}
	return constants.FormBodyBorders[body?.cardTypeId] || constants.FormBodyBorders[1];
};

// Ares | IsCardTypeBody
export const IsCardTypeBody = (body) => {
	if (
		(body?.bodyTypeId === constants.formBodyType.Slider ||
			body?.bodyTypeId === constants.formBodyType.SliderLegend ||
			body?.bodyTypeId === constants.formBodyType.RadioButtonHorizontal ||
			body?.bodyTypeId === constants.formBodyType.ToggleThreeButton ||
			body?.bodyTypeId === constants.formBodyType.ToggleTwoButton ||
			body?.bodyTypeId === constants.formBodyType.ToggleSwitch ||
			body?.bodyTypeId === constants.formBodyType.ToggleSwitchTwoOptions) &&
		body?.cardTypeId !== 1
	) {
		return true;
	}
	return false;
};

// Ares | IsDocUploadBody
export const IsDocUploadBody = (body) => {
	const docUploadTypes = [
		constants.formBodyType.DocumentUploadLegend,
		constants.formBodyType.DocumentUploadPICApprovalRequired,
		constants.formBodyType.DocumentUploadEQRApprovalRequired,
		constants.formBodyType.DocumentUploadPICEQRApprovalRequired,
		constants.formBodyType.DocumentUploadAnyApprovalRequired
	];
	return docUploadTypes.includes(body?.bodyTypeId);
};

export const applyTooltip = (tooltip, theme, tooltipOverlap = false, borderColor, children) => {
	let _tooltip = {
		enabled: false
	};

	if (tooltip !== undefined) {
		_tooltip = {
			enabled: true,
			borderColor: borderColor,
			formatter: function() {
				// The highcharts formatter expects a string containing an HTML
				// https://api.highcharts.com/highcharts/tooltip.formatter
				// For rendering the passed component, ReactDOMServer is used for simplicity, but
				// ReactDOM.render in a unattached node can be done as well.
				// https://reactjs.org/docs/react-dom-server.html
				return ReactDOMServer.renderToString(
					<ThemeProvider theme={theme}>
						{React.cloneElement(children, {
							color,
							percentage,
							point,
							total,
							tooltipMessage,
							x,
							y
						})}
					</ThemeProvider>
				);
			},
			// TODO: Small charts tooltips do not overflow, we need to set this to true and update styling
			outside: tooltipOverlap,
			followPointer: true,
			/*positioner: function(width, height, point) {
				return {
					x: point.plotX + this.now.anchorX,
					y: point.plotY - this.now.anchorY
				};
			},*/
			useHTML: true
		};
	}

	return _tooltip;
};

/**
 * Handler function for executing a callback when a click outside a container is detected. To use this, attach this function to the document's click event (document.addEventListener('click', handleOnClickOutside);).
 * @param {String} elementId Id of the container element in the DOM.
 * @param {Function} onClickOutside Callback function executed when a click outside the container is detected.
 * @param {Event} evt Event object.
 */
export function handleOnClickOutside(elementId, onClickOutside, evt) {
	const elem = document.getElementById(elementId);
	if (elem) {
		const outsideClick = typeof evt.composedPath === 'function' && !evt.composedPath().includes(elem);
		if (outsideClick) {
			onClickOutside(evt);
		}
	}
}

export function valueComparator(value1, value2) {
	const item1 = value1.toString();
	const item2 = value2.toString();

	if (item1.toLowerCase() < item2.toLowerCase()) {
		return -1;
	} else if (item1.toLowerCase() > item2.toLowerCase()) {
		return 1;
	} else {
		return 0;
	}
}

export function objectComparator(obj1, obj2, key) {
	const item1 = obj1[key].toString().trim();
	const item2 = obj2[key].toString().trim();

	if (item1.toLowerCase() < item2.toLowerCase()) {
		return -1;
	} else if (item1.toLowerCase() > item2.toLowerCase()) {
		return 1;
	} else {
		return 0;
	}
}

export function getFrameEssentialQuery(queryParameters, includeQueryParams = []) {
	const searchParams = new URLSearchParams(location.search);

	const params = {};

	const parameter = [...includeQueryParams, 'frameKey', 'sourceFrameKey', 'target', 'isDrawer'];

	for (const [key, value] of searchParams) {
		const found = parameter.find((item) => item.toLowerCase() === key.toLowerCase());

		if (found && value) {
			params[key.toLowerCase()] = value;
		}
	}

	for (const key in queryParameters) {
		if (queryParameters[key]) {
			params[key.toLowerCase()] = queryParameters[key];
		}
	}

	return params;
}

export function getFilteredQueryParameter(queryParameters, excludes = []) {
	const parameter = {};

	const keys = excludes.length > 0 ? excludes : ['documentid', 'taskid', 'engagementid'];

	if (queryParameters) {
		Object.entries(queryParameters)
			.filter(([key]) => !keys.includes(key.toLowerCase()))
			.forEach(([key, value]) => {
				parameter[key] = value;
			});
	}

	return parameter;
}

export const chunk = (arr, size) => {
	return Array.from({length: Math.ceil(arr.length / size)}, (v, i) => arr.slice(i * size, i * size + size));
};

const getDuplicateSections = (duplicateSections = [], parentSectionId, duplicatesArray = []) => {
	const further = duplicateSections.filter((section) => Number(section.archiveImportId) === Number(parentSectionId));

	if (further.length === 0) {
		return;
	}

	while (further.length > 0) {
		const current = further.shift();

		duplicatesArray.push(current);

		getDuplicateSections(duplicateSections, current.id, duplicatesArray);
	}
}
//
export const getSortedSections = (headerSections) => {
	if (headerSections === undefined || headerSections && headerSections.length === 0) {
		return [];
	}
	const sortKey = 'sectionFullName';
	const allSections = headerSections.map((section) => {
		return {
			...section,
			sectionFullName: `${section?.formSectionName ?? section?.name}${(section?.isDuplicate || section?.isCustom) && section?.customLabel
				? ` - ${section?.customLabel}`
				: ''
				}`
		};
	});
	const originalSections = allSections.filter((s) => {
		return s.isCustom === false && s.isDuplicate === false;
	});

	const duplicateSections = allSections.filter((s) => {
		return s.isSummary === false && s.isCustom === false && s.isDuplicate === true;
	});

	let customSections = allSections.filter((s) => {
		return s.isSummary === false && s.isCustom === true && s.isDuplicate === false;
	});

	const duplicateCustomSections = allSections.filter((s) => {
		return s.isSummary === false && s.isCustom === true && s.isDuplicate === true;
	});

	const movedCustomDuplicateSection = duplicateCustomSections.filter((section) => {
		return !allSections.some((s) => Number(s.id) === Number(section.archiveImportId));
	});

	const orderedSections = [];

	originalSections.forEach((section) => {
		orderedSections.push(section);

		const recursive = [];

		getDuplicateSections(duplicateSections, section.id, recursive);

		recursive.sort((a, b) => objectComparator(a, b, sortKey));

		orderedSections.push(...recursive);
	});
	customSections = [...customSections, ...movedCustomDuplicateSection];
	customSections.sort((a, b) => objectComparator(a, b, sortKey));

	customSections.forEach((section) => {
		orderedSections.push(section);

		const recursive = [];

		getDuplicateSections(duplicateCustomSections, section.id, recursive);

		recursive.sort((a, b) => objectComparator(a, b, sortKey));

		orderedSections.push(...recursive);
	});

	return orderedSections;
}
